<template>
    <div class="course">
        <TopMenu></TopMenu>
        <div class="s_banner">
            <img src="../../../assets/images/xb_banner.png" alt=""/>
        </div>
        <Nav></Nav>
        <Column title="最新视频" v-if="list.length > 0">
            <ChildNewList :list="list"></ChildNewList>
        </Column>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import TopMenu from "./module/topmenu"
import Nav from './childnav'
import Subject from './module/subjectList'
import ChildNewList from './module/childnewlist'
import Column from "../column"
import Loading from "../../loading"

export default{
    name: 'Child',
    data(){
        return{
            title: '少儿编程',
            name: this.$route.params.title,
            sortid: this.$route.params.sortid,
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            list: [],           
        }
    },
    computed:{
        showClassList(){
            let name = this.$route.params.title;
            let list = this.childList;
            return list
        }
    },
    created(){
        this.getData(this.name);
    },
    mounted(){
        this.getStatistPv();
    },
    methods:{
        getData(name){
            let idArr = 'child';
            this.isLoading = true;  
            this.axios.get(`/data/${idArr}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                this.list = res.data.courselist;
            })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fchild%2f${this.name}&sid=${this.sortid}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        TopMenu,
        Nav,
        Subject,
        ChildNewList,
        Column,
        Loading    
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        .s_banner{
            margin-bottom: 0.35rem;
            margin-top: 16px;
            img{
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
    }             
</style>   